import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { HOST } from 'config/config';
import { BlobStorageTypeEnumValue } from 'enums/BlobStorageTypeEnum';

/**
 * Upload files to a submission detail
 * Uses the existing AttachedFilesController endpoint
 */
export const useUploadSubmissionDetailFiles = submissionId => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ submissionDetailId, files, blobStorageType = BlobStorageTypeEnumValue.CertificationTool }) => {
      const formData = new FormData();

      // Add all files to FormData
      files.forEach(file => {
        formData.append('files', file);
      });

      const response = await axios.post(`${HOST}/api/dashboard/attached-files/${submissionDetailId}`, formData, {
        params: {
          type: blobStorageType,
          isForDealerPortal: false,
        },
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      return response.data;
    },
    onSuccess: () => {
      // Invalidate the specific submission to refetch with new files
      if (submissionId) {
        queryClient.invalidateQueries({
          queryKey: ['submission', submissionId],
        });
      }
      // Also invalidate list queries
      queryClient.invalidateQueries({
        queryKey: ['submissions'],
      });
    },
  });
};

/**
 * Delete an attached file
 */
export const useDeleteAttachedFile = submissionId => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ entityId, attachedFileId }) => {
      const response = await axios.delete(
        `${HOST}/api/dashboard/attached-files/${entityId}/${attachedFileId}?type=${BlobStorageTypeEnumValue.CertificationTool}`,
      );
      return response.data;
    },
    onSuccess: () => {
      // Invalidate the specific submission to refetch without deleted file
      if (submissionId) {
        queryClient.invalidateQueries({
          queryKey: ['submission', submissionId],
        });
      }
      // Also invalidate list queries
      queryClient.invalidateQueries({
        queryKey: ['submissions'],
      });
    },
  });
};
